import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SynthesisImg from "page/component/SynthesisImg/SynthesisImg.vue";
export default {
  data: function data() {
    var _ref;

    return _ref = {
      enrollList: [],
      search: "",
      pageIndex: 1,
      pageSize: 10,
      totalCount: 10,
      dialogVisible: false,
      IsAdopt: 0,
      joinAttestationId: "",
      dialogVisiblecer: false,
      stuId: "",
      file: "",
      AttestationId: "",
      Id: ""
    }, _defineProperty(_ref, "AttestationId", ""), _defineProperty(_ref, "CreateUserId", ""), _defineProperty(_ref, "CreateDisplayName", ""), _defineProperty(_ref, "Title", ""), _defineProperty(_ref, "CertificateIdentifier", ""), _defineProperty(_ref, "DateCreated", ""), _defineProperty(_ref, "UserCoverUrl", ""), _defineProperty(_ref, "UserIDNumber", ""), _defineProperty(_ref, "isShow", false), _defineProperty(_ref, "imgShow", false), _defineProperty(_ref, "imgurl", ""), _ref;
  },
  props: {},
  components: {
    SynthesisImg: SynthesisImg
  },
  computed: {},
  created: function created() {
    this.getAttestationListall();
  },
  methods: {
    lookImg: function lookImg(event) {
      this.imgurl = event.CertificateCover;
      this.imgShow = true;
    },
    clickChild: function clickChild(isShow) {
      this.dialogVisible = isShow;
      this.getAttestationListall();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.dialogVisiblecer = false;
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getAttestationListall();
    },
    handleCurrentChange: function handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getAttestationListall();
    },
    handleEdit: function handleEdit(val) {
      this.CreateDisplayName = val.CreateDisplayName;
      this.Title = val.Title;
      this.CertificateIdentifier = this.Random();
      this.DateCreated = val.DateCreated;
      this.UserCoverUrl = val.UserCoverUrl == null ? "" : val.UserCoverUrl;
      this.UserIDNumber = val.UserIDNumber == null ? "" : val.UserIDNumber;
      this.joinAttestationId = val.Id;
      this.stuId = val.CreateUserId;
      this.AttestationId = val.AttestationId;
      this.dialogVisible = true;
    },
    Random: function Random() {
      var str = "";

      for (var i = 0; i < 15; i++) {
        var randnum = this.rand(0, 10);
        str += randnum;
      }

      return str;
    },
    rand: function rand(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    shenhe: function shenhe() {
      if (this.IsAdopt == 2) {
        this.dialogVisible = false;
        var that = this;
        this.$http.post("/api/XOrg/StudentManager/updateIsAdopt", {
          Id: this.joinAttestationId,
          IsAdopt: 2
        }).then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getAttestationListall();
          } else {
            that.$message.warning(rst.msg);
          }
        });
      }

      if (this.IsAdopt == 1) {
        this.dialogVisible = false;
        this.dialogVisiblecer = true;
      }
    },
    GoToYes: function GoToYes() {
      var that = this;
      this.$http.post("/api/XOrg/StudentManager/addCertificate", {
        userId: this.stuId,
        url: this.file,
        AttestationId: this.AttestationId
      }).then(function (rst) {
        if (rst.code > 0) {} else {}
      });
      that.$http.post("/api/XOrg/StudentManager/updateIsAdopt", {
        Id: that.joinAttestationId,
        IsAdopt: 1
      }).then(function (res) {
        if (res.code > 0) {
          that.$message.success(res.msg);
          that.dialogVisiblecer = false;
          that.getAttestationListall();
        } else {
          that.$message.warning(res.msg);
        }
      });
    },
    getAttestationListall: function getAttestationListall() {
      var that = this;
      this.$http.post("/api/XOrg/teaCertificate/getAttestation", {
        isSys: true,
        page: this.pageIndex
      }).then(function (rst) {
        if (rst.code > 0) {
          that.enrollList = rst.enrollList;
          that.pageIndex = rst.pagination.pageIndex;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    }
  }
};